import React, {Component}from 'react';


class Estado extends Component {

    ajuste = (estado) => {
        let cambio = ''; 
        cambio = estado.replace("A", "a")
                        .replace("E", "e")
                        .replace(" ", "")
                        .replace("ó", "o")
                        .replace("R", "r");
        return cambio
    }

    render(){
        return (
            <span className={"estado-"+this.ajuste(this.props.tipo)}>{this.props.tipo}</span>
        )  
    }
 

}

export default Estado; 